import axios from 'axios';
import {IStartupSequence} from "./Data.types";

export default class DataApi {
    static async syncNaicsCodes(){
        try {
            let res = await axios.get('/data-sync/naics');
            if (res){
                return res.data as IStartupSequence;
            }
        } catch (e) {
            console.error('Error syncing naics codes', e.message);
            return undefined;
        }
    }
    static async syncPscCodes(){
        try {
            let res = await axios.get('/data-sync/psc');
            if (res){
                return res.data as IStartupSequence;
            }
        } catch (e) {
            console.error('Error syncing pcs codes', e.message);
            return undefined;
        }
    }
    static async syncUsers(){
        try {
            let res = await axios.get('/data-sync/users');
            if (res){
                return res.data as IStartupSequence;
            }
        } catch (e) {
            console.error('Error syncing users', e.message);
            return undefined;
        }
    }
    static async getStartupSequences({ queryKey }){
        try {
            let res = await axios.get('/startup-sequences');
            if (res){
                return res.data as IStartupSequence[];
            }
        } catch (e) {
            console.error('Error syncing users', e.message);
            return undefined;
        }
    }
}